import auth from './auth'
import field from './field'
import user from './user'
import report from './report'
import moderation from './moderation'
import events from './events'
import notification from './notification'
import profile from './profile'
import team from './team'
import schedule from './schedule'
import playground from './playground'

export default (axios) => ({
  auth: auth(axios),
  field: field(axios),
  user: user(axios),
  report: report(axios),
  moderation: moderation(axios),
  events: events(axios),
  notification: notification(axios),
  profile: profile(axios),
  team: team(axios),
  schedule: schedule(axios),
  playground: playground(axios)
})
